/** Matches the streamed/push ingress ID normalization. Invalid scope is never ordinary prose. */
function normalizeOutreachId(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  const id = value.trim();
  return id.length > 0 && id.length <= 64 ? id : null;
}

/** Keep malformed persisted selections distinct from absent ones in the lightweight message view. */
export function readOutreachReplyScope(metadata: unknown): string | null | undefined {
  if (!metadata || typeof metadata !== 'object' || !Object.prototype.hasOwnProperty.call(metadata, 'outreachId')) return undefined;
  return normalizeOutreachId((metadata as { outreachId: unknown }).outreachId);
}

type HandoffMessage = { role?: string; content?: string; outreachId?: string | null; choiceAnswer?: unknown };

/** This suppresses a URL handoff only; it never establishes permission to relay a reply. */
export function isSameOutreachHandoff(message: HandoffMessage, text: string, outreachId?: string | null): boolean {
  if (message.role !== 'USER' || (message.content ?? '').trim() !== text.trim()) return false;
  const expected = outreachId == null ? undefined : normalizeOutreachId(outreachId);
  if (expected === undefined && message.outreachId === undefined) return true;
  // A chip and an ordinary scoped handoff are different USER turns, even if both say "Send".
  return typeof expected === 'string' && message.outreachId === expected && message.choiceAnswer === undefined;
}
